import React, { useState } from 'react';
import {
  Table,
  Button,
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
import IntlMessages from 'util/IntlMessages';
import PropTypes from 'prop-types';

/**
 * UserProgramsTable Component
 * @param {Object} props props
 * @returns {JSX.Element} JSX
 */
function UserProgramsTable({
  programsLoading,
  getProgramsDataSource,
  getProgramsColumns,
  rowSelection,
}) {
  const [showMore, setShowMore] = useState(1);
  return (
    <Table
      dataSource={getProgramsDataSource(showMore)}
      columns={getProgramsColumns}
      className="userPrograms"
      loading={programsLoading}
      rowSelection={rowSelection}
      pagination={false}
      footer={() => (
        <div className="table-footer">
          <Button
            type="text"
            onClick={() => {
              setShowMore(showMore + 1);
            }}
          >
            <IntlMessages id="common.showMore" />
            <DownOutlined />
          </Button>
        </div>
      )}
    />
  );
}

UserProgramsTable.propTypes = {
  programsLoading: PropTypes.bool.isRequired,
  getProgramsDataSource: PropTypes.func.isRequired,
  getProgramsColumns: PropTypes.func.isRequired,
  rowSelection: PropTypes.shape().isRequired,
};

export default UserProgramsTable;
